import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

//import style
import styles from './DividedBox.module.scss';

export default class DividedBoxComponent extends Component {
  static propTypes = {
    className: PropTypes.string,
    logo: PropTypes.string,
    description: PropTypes.string
  };

  static defaultProps = {
    className: '',
    logo: '',
    description: ''
  };

  render() {
    const { className, logo, description } = this.props;

    return (
      <div className={`${styles.DividedBox} ${className}`}>
        <div className={styles.DividedBoxColumn}>
          <img
            src={OptimizeImagesService.adjustImageSize(logo)}
            alt="Award"
            className={styles.DividedBoxLogo}
          />
        </div>
        <div className={styles.DividedBoxColumn}>
          <p className={styles.DividedBoxDescription}>{description}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Companies/components/DividedBox/DividedBox.js